import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import AddTaxesTable from './AddTaxesTable';
import List from '../List';

const taxViewFilters = [
  {
    id: 'ALL_TAXES_VIEW',
    label: 'All Taxes',
    filterFn: () => true
  }
];

class AddTaxesList extends React.Component {
  static propTypes = {
    allTaxes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
        amount: PropTypes.number,
        taxFeeType: PropTypes.string,
        category: PropTypes.string,
        appliedTo: PropTypes.string,
        calculatedOn: PropTypes.string,
        maxDays: PropTypes.number
      })
    ).isRequired,
    handleAdd: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.shape({}),
    categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    calculatedOn: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    appliedTo: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  };

  static defaultProps = {
    loading: true,
    error: null
  };

  render() {
    const { allTaxes, loading, error, handleAdd, categories, appliedTo, calculatedOn } = this.props;

    return (
      <Grid.ScreenClassRender
        render={(screenClass) => (
          <List
            data={allTaxes}
            loading={loading}
            error={error}
            viewFilters={taxViewFilters}
            screenClass={screenClass}
            tableComponent={AddTaxesTable}
            cardComponent={() => {}}
            helpText="Search by name"
            noDataObj={{
              message: 'There are no taxes for that search, or no taxes have been created',
              title: 'No Taxes'
            }}
            searchBy={['name']}
            otherComponentProps={{ handleAdd, categories, appliedTo, calculatedOn }}
            listComponentProps={{ defaultView: 'tableView' }}
            headerComponentProps={{ hideViewToggle: true, hideFilters: true }}
          />
        )}
      />
    );
  }
}

export default AddTaxesList;
